import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
    Header,
    LeftComponentsHeader,
    MiddleComponentsHeader,
    RightComponentsHeader,
} from '../../navigation/Header/Header.style';
import { Nav } from '../../navigation/Nav/Nav';
import { PageTitle } from '../../navigation/Nav/PageTitle';
import { CustomSearch } from '../../navigation/Search/CustomSearch';
import { Clock } from '../../navigation/ToggleUTCLocal/Clock';

export const ResourceHeader = memo(function ResourceHeader({
    search,
    setSearch,
}: {
    search: string;
    setSearch: (e: string) => void;
}) {
    return (
        <Header>
            <LeftComponentsHeader>
                <Nav>
                    <PageTitle>
                        <FormattedMessage id={'resource.page.title'} />
                    </PageTitle>
                </Nav>
            </LeftComponentsHeader>
            <MiddleComponentsHeader>
                <CustomSearch search={search} setSearch={setSearch} />
            </MiddleComponentsHeader>
            <RightComponentsHeader>
                <Clock />
            </RightComponentsHeader>
        </Header>
    );
});
